export default __webpack_public_path__ + "static/media/logo.b550865e.png";